/**
 * @generated SignedSource<<46a46053a842695507e51c70520e1dd5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EventCompetitionsUpdateMutation$variables = {
  competitionId: string;
  eventId: string;
  membersCanReadEvent: boolean;
};
export type EventCompetitionsUpdateMutation$data = {
  readonly updateEventCompetition: {
    readonly node: {
      readonly id: string;
      readonly membersCanReadEvent: boolean;
    };
  };
};
export type EventCompetitionsUpdateMutation = {
  response: EventCompetitionsUpdateMutation$data;
  variables: EventCompetitionsUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "competitionId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membersCanReadEvent"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "competitionId",
        "variableName": "competitionId"
      },
      {
        "kind": "Variable",
        "name": "eventId",
        "variableName": "eventId"
      },
      {
        "kind": "Variable",
        "name": "membersCanReadEvent",
        "variableName": "membersCanReadEvent"
      }
    ],
    "concreteType": "EventCompetitionEdge",
    "kind": "LinkedField",
    "name": "updateEventCompetition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventCompetition",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "membersCanReadEvent",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventCompetitionsUpdateMutation",
    "selections": (v3/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "EventCompetitionsUpdateMutation",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "f5118a3f79177d115dd4f6627b3bae9e",
    "id": null,
    "metadata": {},
    "name": "EventCompetitionsUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation EventCompetitionsUpdateMutation(\n  $eventId: ID!\n  $competitionId: ID!\n  $membersCanReadEvent: Boolean!\n) {\n  updateEventCompetition(eventId: $eventId, competitionId: $competitionId, membersCanReadEvent: $membersCanReadEvent) {\n    node {\n      id\n      membersCanReadEvent\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb992192b47c491191d686271d45f016";

export default node;
